import React from 'react'
import Card from '../nura/card/card'
import Modal from '../modal/modal'
import Button from '../nura/button/button'
import BaseForm from "../base-form/base-form"

import styles from './styles.module.css'

export default ({ show, setShow, onTrigger }) => {
    return (
        <Modal show={show} onClose={() => setShow(false)}>
            <Card variant="modal" style={{ width: 358 }}>
                <BaseForm onBack={() => setShow(false)} title="Retrigger Request">
                    <div className={styles.menuDescription}>
                        <div>Are you sure you want to retrigger this request?</div>
                    </div>                    
                    <div className={styles.actionGroup}>                        
                        <Button style={{ width: '100%' }} variant="error" onClick={() => setShow(false)}>Cancel</Button>
                        <Button style={{ width: '100%' }} variant="outline" onClick={onTrigger}>Yes</Button>                        
                    </div>
                </BaseForm>
            </Card>
        </Modal>
    )
}